import React from 'react';

class DynamicSearchButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }// end constructor
    render() {
        const { colName, buttonName, dynamicName, dynamicSort, handleDynamicValues } = this.props;
        return (
            <>
            {buttonName !== dynamicName
                ? <button onClick={() => handleDynamicValues(buttonName, "ASC", "firstClick")}
                    className={"btn  btn-sort"}><label>{colName}</label><span>▲</span><span>▼</span></button>
                :
                <>
                    {dynamicSort === "ASC" && <button onClick={() => handleDynamicValues(buttonName, "DESC", "changeSort")}
                        className={"btn btn-sort"}><label>{colName}</label><span className='text-primary'>▲</span><span>▼</span></button>}
                    {dynamicSort === "DESC" && <button onClick={() => handleDynamicValues(buttonName, "ASC", "changeSort")}
                        className={"btn btn-sort"}><label>{colName}</label><span>▲</span><span className='text-primary'>▼</span></button>}
                </>
                
            }


            </>
        )
    }// render
}// end class

export default DynamicSearchButton;
